module.exports = __webpack_public_path__ + "img/360-multiop.cf133c4d.jpg";